import APIClient from '@/shared/http/clients/api'

const resourceName = 'card'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetAllReport = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const Search = (boardColumnId = {}, boardArquivado = false, situacao = 1, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardColumnId=${boardColumnId}&boardArquivado=${boardArquivado}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&${!sortValue.includes('sortDiasAtraso') ? 'sort=' : ''}${sortValue}`, config)
const SearchWithDynamicKpi = (boardColumnId = {}, boardArquivado = false, situacao = 1, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/with-dynamic-kpi/?boardColumnId=${boardColumnId}&boardArquivado=${boardArquivado}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&${!sortValue.includes('sortDiasAtraso') ? 'sort=' : ''}${sortValue}`, config)
const SearchAllByDocument = (document = '', limit, index, sortValue = 'dataCriacao,desc', config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=${sortValue}`, config)
const SearchByBoard = (boardId = {}, boardArquivado = false, situacao = {}, filter = '', limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardId=${boardId}&boardArquivado=${boardArquivado}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&sort=posicao`, config)

const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const CreateCardAndPerson = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/person/`, data, config)
const SetLeadOwner = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/update-owners`, data, config)
const Import = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/import-cards/`, data, config)
const VerifyIfExists = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/import-cards/validation`, data, config)

const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const MoveCard = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/move-card/${data.id}`, data, config)
const MoveCardBoard = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/move-card-board/${id}`, data, config)

const PatchSituacao = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}`, data, config)
const PatchLeadOwner = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}/update-leadowner`, data, config)
const PatchObservation = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}/observacao`, data, config)
const PatchDescription = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.cardId}/descricao`, data, config)

const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const CardRepository = {
  GetAll,
  GetById,
  GetAllReport,
  Search,
  SearchWithDynamicKpi,
  SearchAllByDocument,
  SearchByBoard,

  Create,
  CreateCardAndPerson,
  SetLeadOwner,
  Import,
  VerifyIfExists,

  Update,
  MoveCard,
  MoveCardBoard,

  PatchSituacao,
  PatchLeadOwner,
  PatchObservation,
  PatchDescription,

  Delete
}

export default CardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/card.js